export default __webpack_public_path__ + "static/media/sam.82310465.png";